import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { HiMenu, HiX } from 'react-icons/hi'
import logo from '../assets/logo.webp'
import './Navbar.css'

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMenu = () => {
    setMobileMenuOpen(false)
  }

  return (
    <div className='navbar'>

        <div className='logo-section'>
            <img src={logo} alt="Malaika Doula Logo" className='image-section' />
            <logotext className='logo-text'>Malaika Doula</logotext>
        </div>

        <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
            <Link to='/' className="nav-item" onClick={closeMenu}>
                <p>Home</p>
            </Link>
            <Link to='/services' className="nav-item" onClick={closeMenu}>
                <p>Services</p>
            </Link>
            <div className="nav-item about-item desktop-about">
                <p className="about-text">About Us</p>
                <ul className="dropdown">
                    <li>
                        <Link to='/story' className='text-decoration-none' onClick={closeMenu}>
                            <p>My Story</p>
                        </Link>
                    </li>
                    <li>
                        <Link to='/mission' className='text-decoration-none' onClick={closeMenu}>
                            <p>Our Mission</p>
                        </Link>
                    </li>
                </ul>
            </div>
            <p className="mobile-about-label">About Us</p>
            <Link to='/story' className="nav-item mobile-about-item" onClick={closeMenu}>
                <p>My Story</p>
            </Link>
            <Link to='/mission' className="nav-item mobile-about-item" onClick={closeMenu}>
                <p>Our Mission</p>
            </Link>
            <Link to='/reviews' className="nav-item" onClick={closeMenu}>
                <p>Reviews</p>
            </Link>
            <Link to='/jobs' className="nav-item" onClick={closeMenu}>
                <p>Jobs</p>
            </Link>
            <Link to='/inquiry' className="nav-item" onClick={closeMenu}>
                <p>Inquiry</p>
            </Link>
            <Link to='/contact-us' className='contact-btn text-decoration-none' onClick={closeMenu}>
                Contact Us
            </Link>
        </div>

        <div className='hamburger-menu' onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
        </div>

    </div>
  )
}

export default Navbar